var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Ledger5 - Wealth Tracking & Planning")]),_c('v-card-text',[_vm._v("Ledger5 Wealth Tracking & Planning is currently in closed Beta. ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }